import React, { useEffect } from "react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";
import Seo from "../components/common/seo";

import INFO from "../data/user";
import { personSchema, serviceSchema } from "../data/schema";

import "./styles/about.css";

const About = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<React.Fragment>
			<Seo page="about" schema={[personSchema, serviceSchema]} />

			<div className="page-content">
				<NavBar active="about" />
				<div className="content-wrapper">
					<div className="about-logo-container">
						<div className="about-logo">
							<Logo width={46} />
						</div>
					</div>

					<main className="about-container">
						<div className="about-main">
							<div className="about-right-side">
								<h1 className="title about-title">
									{INFO.about.title}
								</h1>

								<div className="subtitle about-subtitle">
									{INFO.about.description}
								</div>

								<div className="about-highlights">
									{INFO.about.highlights.map((highlight) => (
										<div className="about-highlight" key={highlight}>
											{highlight}
										</div>
									))}
								</div>
							</div>

							<div className="about-left-side">
								<div className="about-image-container">
									<div className="about-image-wrapper">
										<img
											src="about.jpg"
											alt="Sharjeel Faiq full-stack developer profile"
											className="about-image"
											width="370"
											height="370"
											decoding="async"
											loading="eager"
										/>
									</div>
								</div>

								<div className="about-socials">
									<Socials />
								</div>
							</div>
						</div>
						<div className="about-socials-mobile">
							<Socials />
						</div>

						<section className="about-supporting-section">
							<h2 className="about-section-title">Services</h2>
							<div className="about-card-grid">
								{INFO.services.map((service) => (
									<div className="about-card" key={service.title}>
										<h3>{service.title}</h3>
										<p>{service.description}</p>
									</div>
								))}
							</div>
						</section>

						<section className="about-supporting-section">
							<h2 className="about-section-title">Skills</h2>
							<div className="about-card-grid">
								{INFO.skills.map((skillGroup) => (
									<div className="about-card" key={skillGroup.group}>
										<h3>{skillGroup.group}</h3>
										<div className="about-tags">
											{skillGroup.items.map((item) => (
												<span className="about-tag" key={item}>
													{item}
												</span>
											))}
										</div>
									</div>
								))}
							</div>
						</section>
					</main>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;
